import { Component } from '@angular/core';

import type { AgEvent, GridApi, ICellRendererParams, IRowNode } from 'ag-grid-community';
import type { ICellRendererAngularComp } from 'ag-grid-angular';

import styles from './ButtonGroupCellRenderer.module.less';

export interface IButtonGroupCellRendererButtonDef {
	action: string;
	onlyIconDisplay?: boolean;
	iconClass?: string;
	label: string;
}

export interface IButtonGroupCellRendererDef {
	buttons: IButtonGroupCellRendererButtonDef[];
	buttonClick: (event: ButtonGroupCellClickEvent) => void;
	verticalLayout?: boolean;
}

export interface ButtonGroupCellClickEvent extends AgEvent {
	action: string;
	rowNode: IRowNode;
}

interface IButtonGroupCellRendererParams extends ICellRendererParams, IButtonGroupCellRendererDef {}

@Component({
	selector: 'button-group-cell-renderer',
	templateUrl: 'ButtonGroupCellRenderer.Component.html',
	host: {
		'[class]': '(verticalLayout ? styles.verticalLayout : "")'
	},
	standalone: false
})
export class ButtonGroupCellRendererComponent implements ICellRendererAngularComp {
	public buttons: IButtonGroupCellRendererButtonDef[];
	public buttonClick: (event: ButtonGroupCellClickEvent) => void;
	public verticalLayout: boolean;

	private gridApi: GridApi;
	private rowNode: IRowNode;
	public readonly styles = styles;

	public agInit(params: IButtonGroupCellRendererParams): void {
		this.updateCell(params);
	}

	public onClick(buttonDef: IButtonGroupCellRendererButtonDef): void {
		this.buttonClick({
			action: buttonDef.action,
			rowNode: this.rowNode
		} as ButtonGroupCellClickEvent);
	}

	public refresh(params: IButtonGroupCellRendererParams): boolean {
		this.updateCell(params);

		return true; // nothing to do on refresh, so signal success
	}

	private updateCell(params: IButtonGroupCellRendererParams): void {
		this.buttons = params.buttons;
		this.gridApi = params.api;
		this.rowNode = params.node;
		this.verticalLayout = params.verticalLayout;
		this.buttonClick = params.buttonClick;
	}
}
